import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import usePermission from "../../../../hooks/usePermission";
import { FeatureStatic } from "../../../../@types/statics/feature.static";
import styles from "./styles.module.scss";
import { IProjectStatus } from "../../../../@types/project/project-status.type";
import { ProjectStatusService } from "../../../../services/api/projectStatus/ProjectStatusService";
import { FormProjectStatus } from "../components/FormProjectStatus";

export const UpdateProjectStatus: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [projectStatus, setProjectStatus] = useState<IProjectStatus>();
  const { id } = useParams();
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.projectStatus.id);

  async function fechProjectStatusById() {
    try {
      setLoading(true);

      if (!id) {
        toast.error("ID do Status de Projeto não fornecido!");
        navigate("/*");
        return;
      }

      const projectStatusResponse = await ProjectStatusService.getProjectStatusById(id);

      if (!projectStatusResponse) {
        toast.error("Status de Projeto não encontrado!");
        navigate("/*");
        return;
      }

      setProjectStatus(projectStatusResponse);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar o Status de Projeto!");
    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {

    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }

    fechProjectStatusById();
  }, [id]);

  return (
    <>
      {loading ? (
       <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
          <CircularProgress size={100} />
       </div>
      ) : (
        <div className={styles.updateCostCenter}>
          <FormProjectStatus pageType="update" projectStatusData={projectStatus} />
        </div>
      )}
    </>
  );
};
